<template>
  <v-container class="px-0 my-3">
    <v-row class="bg-white" justify="center">
      <v-col cols="12" class="mt-5 d-flex justify-center">
        <v-skeleton-loader :loading="logoImage == null" width="117" height="76" class="logo-supermercado">
          <v-img v-if="logoImage != 'no-image'" :src="logoImage" class="cursor-pointer" alt="Logo"></v-img>
          <v-img v-else src="@/assets/images/logo-supermercado.png" class="cursor-pointer" alt="Logo"></v-img>
        </v-skeleton-loader>
      </v-col>
      <v-col cols="12" class="mt-2 text-center">
        <span class="text-color-0" v-if="apps.ios != '' || apps.android != ''">
          Estamos preparando muitas novidades para você.<br>
          Enquanto isso, baixe nosso app e aproveite nossas ofertas!
        </span>
        <span class="text-color-0" v-else>
          Aguarde, estamos preparando muitas novidades para você.
        </span>
      </v-col>
      <v-col class="v-col-4 v-col-lg-2 my-5 d-flex justify-center">
        <a :href="apps.android" target="_blank" v-if="apps.android != ''">
          <img src="@/assets/images/android.png" alt="Ícone Android" class="w-100">
        </a>
      </v-col>
      <v-col class="v-col-4 v-col-lg-2 my-5 d-flex justify-center">
        <a :href="apps.ios" target="_blank" v-if="apps.ios != ''">
          <img src="@/assets/images/ios.png" alt="Ícone iOS" class="w-100">
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'Baixe o App',
  data() {
    return {
      apps: {
        ios: '',
        android: ''
      }
    };
  },
  computed: {
    ...mapState('main', {
      logoImage: 'logoImage'
    })
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
      getFooter: 'getFooter'
    }),
  },
  mounted(){
    this.setConfig().then(function(retorno){
      if(retorno){
        this.getFooter().then(function(response){
          this.apps.ios = response.link_app_store	;
          this.apps.android = response.link_play_store;
        }.bind(this));
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
    }.bind(this));
  }
}
</script>